import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Science as ExperimentIcon } from '@mui/icons-material';
import { DialogTitleWithClose } from '../../../common';
import TemplateSearchFilters from './TemplateSearchFilters';

/**
 * TemplateSelectionDialogHeader Component
 *
 * Displays the dialog header with title and description.
 */
function TemplateSelectionDialogHeader({
  searchQuery,
  onSearchChange,
  categoryFilter,
  onCategoryChange,
  categories,
  isDebouncing,
  onClose,
  disableClose = false,
}) {
  const theme = useTheme();

  return (
    <DialogTitleWithClose
      title={
        <Box>
          <Box display="flex" alignItems="center" gap={1.5} mb={1.5}>
            <ExperimentIcon color="primary" sx={{ fontSize: 28 }} />
            <Typography
              variant="h6"
              fontWeight={600}
              sx={{ fontSize: '1.25rem' }}
            >
              Step 1: Select Template for Experiment
            </Typography>
          </Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ pl: 4.5, mb: 1, lineHeight: 1.6 }}
          >
            Choose a template to create an A/B testing experiment. You can only
            have one active experiment per template.
          </Typography>
          <Box sx={{ pr: 2, mt: 2 }}>
            <TemplateSearchFilters
              searchQuery={searchQuery}
              onSearchChange={onSearchChange}
              categoryFilter={categoryFilter}
              onCategoryChange={onCategoryChange}
              categories={categories}
              isDebouncing={isDebouncing}
            />
          </Box>
        </Box>
      }
      onClose={onClose}
      disableClose={disableClose}
      sx={{
        pb: 1.5,
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.default,
      }}
    />
  );
}

export default TemplateSelectionDialogHeader;
